import _ from "lodash";
import React, {Component} from "react";
import FormField from "../formField/FormField";
import SearchComponent from "../SearchComponent";
import Toggler from "../Toggler";
import Select from 'react-select';
import FileUpload from "../FileUpload";

export class NewAuthorizedPerson extends Component {
    constructor(props) {
        super(props);
        this.state = {
            saCitizen: true
        };
    }

    onToggleCitizen = () => {
        const {saCitizen} = this.state;
        this.setState({saCitizen: !saCitizen});
    };

    render() {
        const {
            errors, newAP, onChange, onAddressChange, handleSelectChange, onResetError, onHandleUpload,
            onHandleRemoveDocument, onSubmit, showUpload, onSearch, isSearchComplete
        } = this.props;
        const shouldDisableInput = !(!this.state.saCitizen || isSearchComplete);

        if (!newAP) return null;
        const showUploadButtons = showUpload ? showUpload : null;

        const phoneOptions = _.map(newAP.telephones, (t) => ({value: t.msisdn, label: t.msisdn}));
        const addressOptions = _.map(newAP.addresses, (t) => ({value: t.line1, label: t.line1}));

        const hasPhoneOptions = _.size(phoneOptions) > 0;
        const hasAddressOptions = _.size(phoneOptions) > 0;


        return (
            <div className="">
                <div className="">
                    <div className="product-heading">
                        New Authorised Person
                    </div>
                    <div className="title-gradient"/>
                </div>
                <Toggler
                    label="South African Citizen / Resident?"
                    isOn={this.state.saCitizen}
                    onToggle={this.onToggleCitizen}
                />
                <div className="">
                    <div className="col-xs-12 col-md-6">
                        <div className="card-container-form">
                            <FormField id="regNumber" className="form-group"
                                       error={errors && errors.identityNumber}>
                                {
                                    !shouldDisableInput ?
                                        <div>
                                            <label>ID/Passport Number <span className="text-danger">*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="idNumber"
                                                value={newAP.identityNumber || ''}
                                                onChange={(event) => {
                                                    errors && errors.identityNumber && onResetError && onResetError('identityNumber');
                                                    onChange(event, 'identityNumber')
                                                }}
                                            />
                                        </div> :
                                        <SearchComponent
                                            label={"ID Number"}
                                            onChange={(event) => {
                                                errors && errors.identityNumber && onResetError && onResetError('identityNumber');
                                                onChange(event, 'identityNumber')
                                            }}
                                            onSearch={onSearch}
                                            searchValue={newAP && newAP.identityNumber || ''}
                                        />
                                }
                            </FormField>

                            <FormField className={"form-group"} id="firstname" error={errors && errors.registeredName}>
                                <label>First Name <span className="text-danger">*</span></label>
                                <input
                                    type="text"
                                    disabled={shouldDisableInput}
                                    className="form-control"
                                    id="firstName"
                                    value={newAP.firstName || ''}
                                    onChange={(event) => {
                                        errors && errors.firstName && onResetError && onResetError('firstName');
                                        onChange(event, 'firstName')
                                    }}
                                />
                            </FormField>

                            <FormField className={"form-group"} id="lastName" error={errors && errors.lastName}>
                                <label>Surname <span className="text-danger">*</span></label>
                                <input
                                    type="text"
                                    className="form-control"
                                    disabled={shouldDisableInput}
                                    id="surname"
                                    value={newAP.lastName || ''}
                                    onChange={(event) => {
                                        errors && errors.lastName && onResetError && onResetError('lastName');
                                        onChange(event, 'lastName')
                                    }}
                                />
                            </FormField>


                            <FormField className={"form-group"} id="contactNum" error={errors && errors.phoneNumber}>
                                <label>Contact Number <span className="text-danger">*</span></label>
                                {
                                    hasPhoneOptions ?
                                        <Select
                                            menuContainerStyle={{zIndex: 999}}
                                            disabled={shouldDisableInput}
                                            name="contactNumber"
                                            onChange={(event) => handleSelectChange(event, 'phoneNumber')}
                                            options={phoneOptions}
                                            value={newAP.phoneNumber || ''}
                                        />
                                        :
                                        <FormField id="number" error={errors && errors.phoneNumber}>
                                            <input
                                                className="form-control"
                                                disabled={shouldDisableInput}
                                                id="contactNumber"
                                                onChange={(event) => {
                                                    errors && errors.phoneNumber && onResetError && onResetError('phoneNumber');
                                                    onChange(event, 'phoneNumber')
                                                }}
                                                type="text"
                                                value={newAP.phoneNumber || ''}
                                            />
                                        </FormField>
                                }
                            </FormField>
                            <FormField className={"form-group"} id="emailAddress" error={errors && errors.email}>
                                <label>Email Address</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    disabled={shouldDisableInput}
                                    id="email"
                                    value={newAP.email || ''}
                                    onChange={(event) => {
                                        errors && errors.email && onResetError && onResetError('email');
                                        onChange(event, 'email')
                                    }}
                                />
                            </FormField>
                        </div>
                    </div>
                    <div className="col-xs-12 col-md-6">
                        <div className="card-container-form">
                            {
                                hasAddressOptions &&
                                <FormField className={"form-group"} id="contactNum" error={errors && errors.addressing}>
                                    <label>Choose Address</label>
                                    <Select
                                        menuContainerStyle={{zIndex: 999}}
                                        disabled={shouldDisableInput}
                                        name="addressing"
                                        onChange={(event) => handleSelectChange(event, 'address')}
                                        options={addressOptions}
                                        value={newAP.address ? newAP.address.line1 : ""}
                                    />
                                </FormField>
                            }
                            <FormField className="form-group" id="regAddress" error={errors && errors.street}>
                                <label htmlFor="individualAddressLine1">Address <span
                                    className="text-danger">*</span></label>
                                <input
                                    className="form-control"
                                    id="individualAddressLine1"
                                    disabled={shouldDisableInput}
                                    onChange={(event) => {
                                        onAddressChange(event, 'line1')
                                    }}
                                    type="text"
                                    value={newAP.address ? newAP.address.line1 : ""}

                                />
                            </FormField>

                            <FormField className="form-group" id="line2" error={errors && errors.suburb}>
                                <label htmlFor="individualAddressLine2">Suburb</label>
                                <input
                                    className="form-control"
                                    id="individualAddressLine2"
                                    disabled={shouldDisableInput}
                                    onChange={(event) => {
                                        onAddressChange(event, 'line2')
                                    }}
                                    type="text"
                                    value={newAP.address ? newAP.address.line2 : ""}
                                />
                            </FormField>

                            <FormField className="form-group" id="regCity" error={errors && errors.city}>
                                <label htmlFor="individualCity">City <span className="text-danger">*</span></label>
                                <input
                                    type="text"
                                    disabled={shouldDisableInput}
                                    className="form-control"
                                    id="individualCity"
                                    value={newAP.address ? newAP.address.line3 : ""}
                                    onChange={(event) => {
                                        onAddressChange(event, 'line3')
                                    }}
                                />
                            </FormField>

                            <FormField className="form-group" id="regPostalCode" error={errors && errors.postalCode}>
                                <label htmlFor="stateOrProvince">Zip/Postal Code <span className="text-danger">*</span></label>
                                <input
                                    type="number"
                                    max={9999}
                                    className="form-control"
                                    disabled={shouldDisableInput}
                                    id="individualZipOrPostalCode"
                                    value={newAP.address ? newAP.address.postalCode : ""}
                                    onChange={(event) => {
                                        onAddressChange(event, 'postalCode')
                                    }}
                                />
                            </FormField>
                            <div style={{zIndex: -1, padding: 0, margin: 0}}>

                                {
                                    showUploadButtons &&
                                    <FormField
                                        className="form-group"
                                        style={{display: "flex", flexDirection: "column"}}
                                        error={errors && errors.proofOfAddress ? ["Document required"] : null}
                                    >
                                        <label>Proof of Address</label>
                                        <FileUpload
                                            documentType={DOC_TYPES.proofOfAddress}
                                            onUpload={(base64, inProgress, onComplete) => {
                                                errors && errors.proofOfAddress && onResetError('proofOfAddress');
                                                onHandleUpload && onHandleUpload(base64, inProgress, onComplete, DOC_TYPES.proofOfAddress)
                                            }}
                                            onRemoveDocument={() => {
                                                errors && errors.proofOfAddress && onResetError('proofOfAddress');
                                                onHandleRemoveDocument && onHandleRemoveDocument(DOC_TYPES.proofOfAddress);
                                            }}
                                        />
                                    </FormField>
                                }

                                {
                                    showUploadButtons &&
                                    <FormField
                                        className="form-group"
                                        style={{display: "flex", flexDirection: "column"}}
                                        error={errors && errors.proofOfId ? ["Document required"] : null}
                                    >
                                        <label>Proof of ID</label>
                                        <FileUpload
                                            documentType={DOC_TYPES.proofOfId}
                                            onUpload={(base64, inProgress, onComplete) => {
                                                errors && errors.proofOfId && onResetError('proofOfId');
                                                onHandleUpload && onHandleUpload(base64, inProgress, onComplete, DOC_TYPES.proofOfId)
                                            }}
                                            onRemoveDocument={() => {
                                                errors && errors.proofOfId && onResetError('proofOfId');
                                                onHandleRemoveDocument && onHandleRemoveDocument(DOC_TYPES.proofOfId);
                                            }}
                                        />
                                    </FormField>
                                }
                            </div>
                        </div>
                    </div>
                </div>

                <div className="action-button-container" style={{width: "100%"}}>
                    <div/>
                    <button
                        className="action-btn-secondary"
                        onClick={onSubmit}
                        type="button"
                    >Add
                    </button>
                </div>
            </div>
        )

    }
}